import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { generalReducerValues } from '../../../../../General.reducer';
import EventTypes from './widgets/EventTypes/EventTypes';
import ModuleWrapper from '../../../Wrappers/ModuleWrapper/ModuleWrapper';
import WrapperContainer from '../../../Wrappers/WrapperContainer/WrapperContainer';
import { Configuration_EventsConfig_Module_Redcuer_Values } from './reducer';
import EventsManagement from './widgets/EventsManagement/EventsManagement';
import EventsFileUpload from './widgets/EventsFileUpload/EventsFileUpload';

const EventsConfig: React.FC = ({}) => {
    const { selectedWidgetKey } = useSelector(Configuration_EventsConfig_Module_Redcuer_Values);

    return (
        <ModuleWrapper>
            <WrapperContainer>
                {selectedWidgetKey === 'eventsManagement' && <EventsManagement />}
                {selectedWidgetKey === 'eventsFileUpload' && <EventsFileUpload />}
                {selectedWidgetKey === 'eventTypes' && <EventTypes />}
            </WrapperContainer>
        </ModuleWrapper>
    );
};

export default EventsConfig;
